import { create } from "zustand";
// Create the store
const useAuthStore = create((set) => ({
    user: null,
    isLoggedIn: false,
    onboardingStep: "personas",
    setUser: (userData) => set({ user: userData, isLoggedIn: true }),
    logout: () => set({ user: null, isLoggedIn: false }),
    setOnboardingStep: (onboardingStep) => {
        // console.log("Updating onboardingStep:", onboardingStep);
        set({ onboardingStep });
    },
}));
export default useAuthStore;
// import { create } from "zustand";
// import Cookies from "js-cookie"; // Import a library for cookie handling
// // Define the user type
// export interface User {
//   name: string;
//   email: string;
//   picture?: string; // optional property for user's profile image
// }
// // Define the state structure
// interface AuthState {
//   user: User | null;
//   isLoggedIn: boolean;
//   onboardingStep: string;
//   setUser: (userData: User, expiry?: any) => void;
//   logout: () => void;
//   setOnboardingStep: (onboardingStep: string) => void;
// }
// // Utility functions for cookie handling
// const COOKIE_NAME = "authUser";
// // Save user data to a cookie
// const setAuthCookie = (userData: User, expiry?: any) => {
//   Cookies.set(COOKIE_NAME, JSON.stringify(userData), { expires: 30 }); // Cookie expires in 7 days
// };
// // const setAuthCookie = (userData: User, expiry: string) => {
// //   const expirationDate = new Date(expiry); // Convert expiry string to Date
// //   const maxAge = Math.floor((expirationDate.getTime() - Date.now()) / 1000); // Calculate max-age in seconds
// //   if (maxAge > 0) {
// //     Cookies.set(COOKIE_NAME, JSON.stringify(userData), {
// //       expires: maxAge / 86400,
// //       sameSite: "strict",
// //     }); // Convert max-age to days
// //   } else {
// //     console.error("Provided expiry is in the past.");
// //   }
// // };
// // Read user data from a cookie
// const getAuthCookie = (): User | null => {
//   console.log(Cookies.get());
//   const userData = Cookies.get(COOKIE_NAME);
//   return userData ? JSON.parse(userData) : null;
// };
// // Remove the cookie
// const clearAuthCookie = () => {
//   Cookies.remove(COOKIE_NAME);
// };
// // Create the store
// const useAuthStore = create<AuthState>((set) => ({
//   // Initialize state from the cookie if it exists
//   user: getAuthCookie(),
//   isLoggedIn: !!getAuthCookie(),
//   onboardingStep: "personas",
//   // Set user and save to cookie
//   setUser: (userData: User, expiry?: any) => {
//     setAuthCookie(userData, expiry); // Save to cookie
//     set({ user: userData, isLoggedIn: true });
//   },
//   // Logout and clear the cookie
//   logout: () => {
//     clearAuthCookie(); // Remove from cookie
//     set({ user: null, isLoggedIn: false });
//   },
//   setOnboardingStep: (onboardingStep: string) => {
//     console.log("Updating onboardingStep:", onboardingStep);
//     set({ onboardingStep });
//   },
// }));
// export default useAuthStore;
